import React from "react";

interface AlertProps {
  children: React.ReactNode;
  className?: string;
}

export function Alert({ children, className = "" }: AlertProps) {
  return (
    <div className={`rounded-md bg-red-50 p-4 bg-red-50 ${className}`}>
      <div className="flex">
        <div className="shrink-0">
          <span className={"iconoir-xmark-circle mt-1 text-red-600"} />
        </div>
        <div className="ml-3 text-red-600">{children}</div>
      </div>
    </div>
  );
}
